import { Alert, AlertTitle } from "@mui/material";
import localisations from "../../localisation";

type FileErrorPaneProps = {
    errorGuid: string | undefined;
};

function FileImportInvalidPane(props:FileErrorPaneProps) {
    const { title, description } = localisations.fileImportInvalidPane;

    return (
        <Alert severity="error">
            <AlertTitle>{title}</AlertTitle>
            {description}{props.errorGuid !== undefined && props.errorGuid?.length > 0 ? (" '" + props.errorGuid + "'."):(<></>)}
        </Alert>
    );
}

export default FileImportInvalidPane;
